import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
const checkPassword = () => { // 숫자 영문 만 가능하게 변경
    return helpers.regex('alphaNum', /^[A-Za-z0-9]*$/)
};

const checkString = () => { // 한글 + 부호는 - 만 입력가능
    return helpers.regex('alpha', /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ\-]*$/)
};

const checkNumber = () => { // 숫자만 입력 가능
    return helpers.regex('alpha', /^[0-9]*$/);
};

Vue.use(SimpleVueValidation);
export default {
    data() {
        return{
            memo: '',
            files:[],
            hashList:[],

        }
    },
    validators: {
        memo: function (value) {
            return Validator.value(value)
        },
        files: function (value) {
            return Validator.value(value)
        },
        hashList: function (value) {
            return Validator.value(value)
        },
    },
    methods:{
    }
}
